exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".global-filter-popover {\n  font-family: \"Source Sans Pro\", sans-serif;\n  width: 220px; }\n  .global-filter-popover .ant-popover-arrow {\n    display: none; }\n  .global-filter-popover .global-filter-header:first-of-type {\n    margin-top: 10px;\n    display: inline-block; }\n  .global-filter-popover .global-filter-header {\n    margin-bottom: 10px;\n    display: inline-block;\n    font-size: 14px; }\n  .global-filter-popover .global-filter-checkbox {\n    display: inline; }\n  .global-filter-popover .ant-checkbox-group {\n    font-size: 12px; }\n  .global-filter-popover .ant-checkbox-group:last-of-type {\n    margin-bottom: 10px; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/lib/loader.js!./client/modules/Analytics/components/common/GlobalFilterSelector/style.scss
// module id = 985
// module chunks = 0